import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {TrailerEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconEdit, IconTrash} from "@tabler/icons-react";

export type TrailerAction = "EDIT" | "DELETE"

export type TrailerActionMenuDropdownProps = {
  trailer: TrailerEntity
  onActionClick?: (action: TrailerAction) => void
}

export const TrailerActionMenuDropdown = (props: TrailerActionMenuDropdownProps) => {
  const {trailer, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<TrailerAction> = useMemo(() => {
    const actions = new Set<TrailerAction>()
    if (hasAccess("trailer_edit")) {
      actions.add("EDIT")
    }
    if (hasAccess("trailer_delete")) {
      actions.add("DELETE")
    }
    return actions
  }, [trailer, hasAccess])

  const _onActionClick = useCallback((action: TrailerAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT") &&
        <Menu.Item
          onClick={() => _onActionClick("EDIT")}
          icon={<IconEdit size={14}/>}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
      {actions.has("DELETE") &&
        <>
          {actions.size > 1 && <Menu.Divider/>}
          <Menu.Item
            onClick={() => _onActionClick("DELETE")}
            icon={<IconTrash size={14}/>}
            color="red">
            {t("common.action.delete", "Delete")}
          </Menu.Item>
        </>
      }
    </>
  )
}
